"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Minus = function Minus() {
  return _react["default"].createElement("svg", {
    className: "minus-icon",
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "minus-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "minus-id"
  }, "Remove Currency Icon"), _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: "minus-circle",
    cx: "11",
    cy: "11",
    r: "11"
  }), _react["default"].createElement("filter", {
    x: "-3.4%",
    y: "-3.4%",
    width: "106.8%",
    height: "113.6%",
    filterUnits: "objectBoundingBox",
    id: "minus-filter"
  }, _react["default"].createElement("feOffset", {
    dx: "0",
    dy: "1.5",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), _react["default"].createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0506963315 0",
    type: "matrix",
    "in": "shadowOffsetOuter1"
  }))), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-291.000000, -1031.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(153.000000, 947.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(138.000000, 84.000000)"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("use", {
    fill: "black",
    fillOpacity: "1",
    filter: "url(#minus-filter)",
    xlinkHref: "#minus-circle"
  }), _react["default"].createElement("use", {
    fill: "#FF3B30",
    fillRule: "evenodd",
    xlinkHref: "#minus-circle"
  })), _react["default"].createElement("rect", {
    fill: "#FFFFFF",
    x: "5.5",
    y: "10.5",
    width: "11",
    height: "1"
  })))))));
};

var _default = Minus;
exports["default"] = _default;